export default function ContactMethods() {
  const methods = [
    {
      icon: 'ri-phone-line',
      title: 'Телефон',
      value: '+375 (25) 502-44-78',
      href: 'tel:+375255024478',
      action: 'Позвонить',
    },
    {
      icon: 'ri-telegram-line',
      title: 'Telegram',
      value: '@a_sivko',
      href: 'https://t.me/a_sivko',
      action: 'Написать',
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      value: 'info@business-training.by',
      href: 'mailto:info@business-training.by',
      action: 'Написать',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Локация',
      value: 'Минск, Беларусь',
      desc: 'Работаем по Беларуси, России, Казахстану, Узбекистану, Израилю. Онлайн — по всему миру.',
      action: null,
      href: null,
    },
  ];

  return (
    <section id="contact-methods" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Способы связи
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Выберите удобный способ — мы на связи. Все заявки обрабатываются лично, без шаблонных ответов.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {methods.map((m, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 md:p-7 flex flex-col">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mb-5">
                <i className={`${m.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{m.title}</h3>
              {m.href ? (
                <a href={m.href} className="text-teal-600 font-medium text-sm hover:text-teal-700 transition-colors break-all">
                  {m.value}
                </a>
              ) : (
                <p className="text-gray-700 font-medium text-sm">{m.value}</p>
              )}
              {m.desc && <p className="text-xs text-gray-500 mt-2 leading-relaxed">{m.desc}</p>}
              {m.action && m.href && (
                <a
                  href={m.href}
                  className="mt-auto pt-4"
                >
                  <span className="inline-flex items-center gap-2 bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer">
                    {m.action}
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}